import React, { useState } from 'react'
import { Tooltip as ReactTooltip } from 'react-tooltip';

/* Import Icons */
import { IconLibrary } from  '@/interfaces/IconLibrary';
import Icon from '../icons/Icons';

/* Import Toast */
import Toast, { IToastVariables, ToastMessageType } from  '@/components/elements/global/ToastNotification';

/* styles */
import  '@/css/global/copyField.scss';

const CopyField = ({text, styleClass, successMessage, failMessage, tooltip, tooltipId}:{text:string, styleClass?:string, successMessage:string, failMessage:string, tooltip?:string, tooltipId?:string}) => {
    
    //success toast message handling
    const [toastVariables, setToastVariables] = useState<IToastVariables>({messageType: undefined, message: undefined});
    const [showToast, setShowToast] = useState<boolean>();
    
    async function handleClick(){
        try {
            await navigator.clipboard.writeText(text)
            setShowToast(true);
            setToastVariables({messageType: ToastMessageType.SUCCESS, message: successMessage})
        }
        catch{
            setShowToast(true);
            setToastVariables({messageType: ToastMessageType.WARNING, message: failMessage})
        }
    }

    

    return <>
     {showToast && toastVariables?.messageType &&
         <Toast show={showToast} closeToast={() => setShowToast(false)} messageType={toastVariables?.messageType}>
            {toastVariables?.message}
        </Toast>
    }
    <div className={`copyfield-container ${styleClass}`}>
        <input className='copy-text' value={text} type='text' readOnly name={text} aria-label={text}/> 
        {!!tooltip &&<ReactTooltip place="top" className='thrive-tooltip copy-tooltip' delayHide={1000} id={tooltipId}>
            {tooltip}
        </ReactTooltip>}
        <button data-tip="React-tooltip" data-tooltip-id={tooltipId} className='copy-button' name='copy to clipboard' onClick={handleClick} aria-label={'copy to clipboard'}>
            <Icon iconName={IconLibrary.COPY} color='white' sizeInPx='16'/>
        </button>
    </div></>
}

export default CopyField
